import React from "react";
import axios from "axios";
import {showSnackError, toggleLoader} from "../store/global/global-slice";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";

export const AxiosSettings = ({children}) => {
    const dispatch = useDispatch();
    const history = useHistory();

    axios.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        dispatch(toggleLoader(false));

        if (error?.response?.status === 302) {
            return Promise.resolve(error);
        }

        if (error?.response?.status === 409) {
            return Promise.reject(error.response?.data);
        }

        let errorObj: { [key: string]: string[] } = error.response?.data;
        if (error.response?.data?.details) {
            errorObj = error.response?.data?.details;
        }
        let errorText = '';

        if (typeof errorObj === "string") {
            errorText = errorObj;
        } else if (errorObj) {
            if ('non_field_errors' in errorObj) {
                errorText += errorObj.non_field_errors.join('\n');
                delete errorObj.non_field_errors;
            }
            for (let errorObjKey in errorObj) {
                if (errorText.length > 0) {
                    errorText += '\n';
                }

                if (typeof errorObj[errorObjKey] === 'object') {
                    errorText += errorObjKey + ': ' + errorObj[errorObjKey].join('\n');
                } else {
                    errorText += errorObjKey + ': ' + errorObj[errorObjKey];
                }
            }
        } else {
            errorText = 'Wystąpił błąd.'
        }

        if (error && (error.code === 'publisher_has_already_linked_user' || error.code === 'publisher_already_managed' || error.code === 'publisher_inactive')) {

        } else {
            dispatch(showSnackError(errorText));
        }

        if (error?.response?.status === 401) {
            axios.defaults.headers.common['Authorization'] = '';
            localStorage.removeItem('Token');
            history.push('/login');
        }
        return Promise.reject(error);
    })

    return <>
        {children}
    </>;
}